'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_sign_SignView$$anon$15() {
  this.bW6 = null;
  this.bW4 = null;
  this.bW5 = false;
  this.bW2 = null;
  this.bW3 = false;
  this.bW7 = false;
  this.bW8 = false;
  this.bW6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_sign_SignView$$anon$15 as $c_Lpresto_pages_sign_SignView$$anon$15 };
$p = $c_Lpresto_pages_sign_SignView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_sign_SignView$$anon$15;
/** @constructor */
function $h_Lpresto_pages_sign_SignView$$anon$15() {
}
export { $h_Lpresto_pages_sign_SignView$$anon$15 as $h_Lpresto_pages_sign_SignView$$anon$15 };
$h_Lpresto_pages_sign_SignView$$anon$15.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bW6;
});
$p.t = (function() {
  if ((!this.bW5)) {
    this.bW4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("latitude", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("longitude", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bW5 = true;
  }
  return this.bW4;
});
$p.ae = (function() {
  if ((!this.bW3)) {
    this.bW2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bW3 = true;
  }
  return this.bW2;
});
$p.w = (function() {
  if ((!this.bW8)) {
    this.bW7 = false;
    this.bW8 = true;
  }
  return this.bW7;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_sign_SignView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_sign_SignView$$anon$15, "presto.pages.sign.SignView$$anon$15", ({
  WZ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_sign_SignView$$anon$15 as $d_Lpresto_pages_sign_SignView$$anon$15 };
//# sourceMappingURL=presto.pages.sign.-Sign-View$$anon$15.js.map
